import React from "react";
import {connect} from "react-redux";
import List from '../../../components/CRM/List';
import {
  Datagrid,
  TextField,
  ChipField,
  DateField,
  ReferenceField,
  refreshView as refreshViewAction
} from "admin-on-rest";
import ActionBar from "../../../components/CRM/ActionBar/";
import DeviceFilter from "./DeviceFilter";
import ActionMenu from "../../../components/CRM/ActionMenu";
import DeviceTextField from "./DeviceTextField"; 

class DeviceDataList extends React.Component {
  render() {
    const props = {...this.props};

    return (
      <List
        title="resources.devices.name"
        {...props}
        actions={<ActionBar {...props} deleteButton={false} createButton={false} />}
        filters={<DeviceFilter />}
      >
        <Datagrid>
          <ReferenceField
            label="resources.devices.fields.storeName"
            source="kiosk_id"
            reference="kiosks"
            linkType={false}
          >
            <ChipField source="name" />
          </ReferenceField>

          <TextField
            label="resources.devices.fields.deviceSerialNumber"
            source="id"
          />
          <DeviceTextField
            label="resources.devices.fields.uptime"
            source="uptime"
          />
          <DateField
            label="resources.devices.fields.lastReport"
            source="last_report_at"
          />

          <ActionMenu
            deleteButton={false}
            showButton={true}
            editButton={true}
          />
        </Datagrid>
      </List>
    );
  }
}

const mapStateToProps = state => {
  return {
    record: state.admin.resources.devices.data
  };
};

export default connect(
  mapStateToProps,
  {
    refreshView: refreshViewAction
  }
)(DeviceDataList);



// WEBPACK FOOTER //
// ./src/containers/CRM/Devices/DeviceDataList.js